import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminPlansResponse } from '@utils/types/admin';

export const ADMIN_PLANS_QUERY_KEY = 'adminPlans';

/**
 * Hook to fetch all plans for on-prem
 *
 * GET /api/admin/on-prem/plans
 *
 * Returns list of all plans (default + custom)
 */
export const useGetAdminPlans = () => {
  const fetchPlans = async () => {
    const url = `api/admin/on-prem/plans`;
    const response = await Axios.get<AdminPlansResponse>(url);
    return response.data;
  };

  return useQuery<AdminPlansResponse, AxiosError<BaseError>>(
    [ADMIN_PLANS_QUERY_KEY],
    fetchPlans,
    {
      useErrorBoundary: false,
      staleTime: 5 * 60 * 1000
    }
  );
};
